import React from 'react';
import { utcDateKey, utcDateKeyDaysAgo } from '../dateTime';

const STATUSES = [
  { key: 'all', label: 'Всі' },
  { key: 'passed', label: 'Пройшли' },
  { key: 'blocked', label: 'Заблоковані' },
];

const shiftDays = (days) => utcDateKeyDaysAgo(days);

const today = () => utcDateKey();

const PRESETS = [
  { key: 'today', label: 'Сьогодні', range: () => ({ startDate: today(), endDate: today() }) },
  { key: 'yesterday', label: 'Учора', range: () => ({ startDate: shiftDays(1), endDate: shiftDays(1) }) },
  { key: '7d', label: '7 днів', range: () => ({ startDate: shiftDays(6), endDate: today() }) },
  { key: '30d', label: '30 днів', range: () => ({ startDate: shiftDays(29), endDate: today() }) },
];

const formatNumber = (value) =>
  value === null || value === undefined ? '—' : Number(value).toLocaleString('uk-UA');

const formatShare = (part, whole) => {
  if (!whole || !part) return '0';
  const value = (part / whole) * 100;
  if (value >= 10) return value.toFixed(0);
  if (value >= 1) return value.toFixed(1);
  return value.toFixed(2);
};

function Field({ label, className = '', children }) {
  return (
    <div className={`f-field ${className}`}>
      <span className="f-label">{label}</span>
      <div className="f-control">{children}</div>
    </div>
  );
}

function Segmented({ items, value, onChange }) {
  return (
    <div className="seg">
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          className={`seg-btn${value === item.key ? ' is-active' : ''}`}
          onClick={() => onChange(item.key)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}

export default function StatsFilters({
  filters,
  setFilters,
  statusFilter,
  setStatusFilter,
  onSearch,
  count,
  filteredCount,
  onExport,
  loading,
  blockedCount,
}) {
  const patch = (changes) => setFilters({ ...filters, ...changes });

  const activePreset = PRESETS.find((preset) => {
    const range = preset.range();
    return range.startDate === filters.startDate && range.endDate === filters.endDate;
  });

  const hasFilters = Boolean(
    filters.appId ||
      filters.deviceID ||
      filters.adId ||
      filters.urlPart ||
      filters.clickLog ||
      statusFilter !== 'all'
  );

  const resetFilters = () => {
    patch({ appId: '', deviceID: '', adId: '', urlPart: '', clickLog: '' });
    setStatusFilter('all');
  };

  return (
    <div className="filters-card app-editor-card compact-card mt-3">
      <div className="filters-bar">
        <div className="filters-stats">
          <div className="fstat">
            <span className="fstat-label">Знайдено</span>
            <span className="fstat-value">{formatNumber(count)}</span>
          </div>
          <div className="fstat">
            <span className="fstat-label">На сторінці</span>
            <span className="fstat-value">{formatNumber(filteredCount ?? 0)}</span>
          </div>
          <div className="fstat">
            <span className="fstat-label">Заблоковано</span>
            <span className="fstat-value">
              {formatNumber(blockedCount ?? 0)}
              {count ? <em className="fstat-share">{formatShare(blockedCount, count)}%</em> : null}
            </span>
          </div>
        </div>

        <div className="filters-actions">
          {hasFilters ? (
            <button type="button" className="fbtn" onClick={resetFilters}>
              Скинути
            </button>
          ) : null}
          <button type="button" className="fbtn is-primary" onClick={onSearch} disabled={loading}>
            {loading ? 'Оновлення…' : 'Оновити'}
          </button>
          <button type="button" className="fbtn" onClick={onExport} disabled={!filteredCount}>
            Export
          </button>
        </div>
      </div>

      <div className="filters-grid">
        <Field label="Період" className="f-span-2">
          <Segmented
            items={PRESETS.map((preset) => ({ key: preset.key, label: preset.label }))}
            value={activePreset?.key || ''}
            onChange={(key) => patch(PRESETS.find((preset) => preset.key === key).range())}
          />
        </Field>

        <Field label="Від">
          <input
            type="date"
            className="f-input"
            value={filters.startDate}
            max={filters.endDate}
            onChange={(e) => patch({ startDate: e.target.value })}
          />
        </Field>

        <Field label="До">
          <input
            type="date"
            className="f-input"
            value={filters.endDate}
            min={filters.startDate}
            onChange={(e) => patch({ endDate: e.target.value })}
          />
        </Field>

        <Field label="Статус" className="f-span-2">
          <Segmented items={STATUSES} value={statusFilter} onChange={setStatusFilter} />
        </Field>

        <Field label="App ID">
          <input
            className="f-input"
            placeholder="усі додатки"
            value={filters.appId}
            onChange={(e) => patch({ appId: e.target.value })}
          />
        </Field>

        <Field label="Click Log">
          <input
            className="f-input"
            placeholder="geo blocked, 200…"
            value={filters.clickLog}
            onChange={(e) => patch({ clickLog: e.target.value })}
          />
        </Field>

        <Field label="Device ID">
          <input
            className="f-input"
            placeholder="пошук"
            value={filters.deviceID}
            onChange={(e) => patch({ deviceID: e.target.value })}
          />
        </Field>

        <Field label="Ad ID">
          <input
            className="f-input"
            placeholder="пошук"
            value={filters.adId}
            onChange={(e) => patch({ adId: e.target.value })}
          />
        </Field>

        <Field label="Naming / URL / Deeplink / Referer" className="f-span-2">
          <input
            className="f-input"
            placeholder="неймінг або посилання"
            value={filters.urlPart}
            onChange={(e) => patch({ urlPart: e.target.value })}
          />
        </Field>
      </div>
    </div>
  );
}
